<template>
  <div class="h100-40 h-scroll">
    <ejs-grid
      ref="grid"
      height="calc(100% - 0px)"
      :dataSource="data"
      :allowReordering="true"
      :allowResizing="true"
    >
      <e-columns :columns='shipColumns' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'>
        <e-column field='id' minWidth='10' :headerText='$t("NSMF.name")' :visible='false' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='name' minWidth='10' :headerText='$t("NSMF.name")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='sST' minWidth='10' :headerText='$t("NSMF.sst")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='sSTFormat'></e-column>
        <e-column field='sd' minWidth='10' :headerText='$t("NSMF.sd")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'  :formatter='sdFormat'></e-column>
        <e-column field='mcc' minWidth='10' :headerText='$t("NSMF.mcc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='mccFormat'></e-column>
        <e-column field='mnc' minWidth='10' :headerText='$t("NSMF.mnc")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip' :formatter='mncFormat'></e-column>
        <e-column field='maxNumberOfUEs' minWidth='10' :headerText='$t("NSMF.maxNumberofUEs")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='caps' minWidth='10' :headerText='$t("NSMF.caps")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='throughPut' minWidth='10' :headerText='$t("NSMF.gbps")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='numberOfStation' minWidth='10' :headerText='$t("NSMF.gnbNum")' textAlign='Center' width='10%' clipMode='EllipsisWithTooltip'></e-column>
      </e-columns>
    </ejs-grid>
    <ejs-pager
      ref="pager"
      @click="getServiceProfileListData()"
      :pageSize="page.pageSize"
      :currentPage="page.pageNo"
      :totalRecordsCount="page.totalCount"
      :pageCount="page.pageCount"
    ></ejs-pager>
    <CustomDialog
      ref="addDialog"
      :element="dialog.element.addDialogSetting"
      :styles="dialog.element.addDialogSetting.styles"
    >
      <template v-slot:dialog-content>
        <AddServiceProfile ref="addContent"></AddServiceProfile>
      </template>
    </CustomDialog>
    <CustomDialog
      ref="instanceDialog"
      :element="dialog.element.instanceDialogSetting"
      :styles="dialog.element.instanceDialogSetting.styles"
    >
      <template v-slot:dialog-content>
        <InstanceServiceProfile ref="instanceContent" :index="instanceIndex"></InstanceServiceProfile>
      </template>
    </CustomDialog>
  </div>
</template>
<script>
import {
  Reorder,
  Resize,
  ExcelExport,
  ContextMenu
} from "@syncfusion/ej2-vue-grids";
import CustomDialog from "../../common/CustomDialog";
import AddServiceProfile from "./AddServiceProfile";
import InstanceServiceProfile from "./InstanceServiceProfile";
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: "ServiceProfileTable",
  components: {
    CustomDialog,
    AddServiceProfile,
    InstanceServiceProfile
  },
  data() {
    return {
      runModeRadioValue:"1",
      data: [],
      page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        pageCount: 10
      },
      instanceIndex: 0,
      instanceStatus: true,

      dialog: {
        element: {
          addDialogSetting: {
            styles: {
              width: "860px",
              height: "717px",
              model: true,
              visible: false
            },
            target: "#app",
            title: this.$t("NSMF.createServiceProfile"),
            refName: "add",
            isClose: true,
            buttonGroup: [
              {
                click: this.dialogHide,
                buttonModel: { content: this.$t("Common.cancel") }
              },
              {
                click: this.saveAddTask,
                buttonModel: {
                  content: this.$t("Common.confirm"),
                  isPrimary: true
                }
              }
            ]
          },
          instanceDialogSetting: {
            styles: {
              width: "950px",
              height: "717px",
              model: true,
              visible: false
            },
            refName: "instance",
            title: this.$t("NSMF.instance"),
            isClose: false,
            buttonGroup: [
              {
                click: this.dialogHide,
                buttonModel: { content: `${this.$t("Common.cancel")}` }
              },
              {
                click: this.prevInstance,
                buttonModel: {
                  content: `${this.$t("Common.previous")}`,
                  cssClass: "h-security-display-none"
                }
              },
              {
                click: this.nextInstance,
                buttonModel: { content: `${this.$t("Common.next")}` }
              }
            ]
          }
        }
      },
      shipColumns: [
        {
          field: "ShippedDate",
          headerText: "Shipped Date",
          format: "yMd",
          textAlign: "Right",
          width: 150,
          minWidth: 10
        },
        {
          field: "ShipCountry",
          headerText: "Ship Country",
          width: 150,
          minWidth: 10
        }
      ]
    };
  },
  provide: {
    grid: [Reorder, Resize, ExcelExport, ContextMenu]
  },
  methods: {
    sSTFormat(grids, data) {
      if (null !== data && undefined !== data && data.sST === "1") {
        return "eMBB";
      } else if (null !== data && undefined !== data && data.sST === "2") {
        return "URLLC";
      } else if (null !== data && undefined !== data && data.sST === "3") {
        return "MIoT";
      } else {
        return "V2X";
      }
    },

    mccFormat(grids, data) {
      return data.pLMNList.split(":")[0];
    },
    mncFormat(grids, data) {
      return data.pLMNList.split(":")[1];
    },
    sdFormat(grids, data) {
      return data.sNSSAIList.split(":")[1];
    },
    dialogHide() {
      this.instanceIndex = 0;
      this.$refs.addDialog.clear();
      this.$refs.addDialog.close();
      this.$refs.instanceDialog.clear();
      this.$refs.instanceDialog.close();
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.no_checked")}`
        });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.too_many_checked")}!`
        });
        return false;
      }
      return selectedRecords;
    },
    getServiceProfileListData() {
      // 获取表格数据
      const This = this;
      This.page.pageNo = This.$refs.pager.ej2Instances.currentPage;
      const params = {
        pageNo: parseInt(This.page.pageNo, 10),
        pageSize: parseInt(This.page.pageSize, 10)
      };
      This.$axios
        .get(
          `/lte/ems/networkSlice/listServiceProfile?pageNo=${params.pageNo}&pageSize=${params.pageSize}`
        )
        .then(response => {
          if (
            response &&
            response.status === 200 &&
            response.data.errorCode === "SUCCESS"
          ) {
            const result = response.data.resultVal;
            This.page.totalCount = result.totalCount;
            This.data = result.result;
          } else {
            EventBus.$emit("toast", {
              type: "error",
              content: response.data.errorString
            });
          }
        });
    },
    addServiceProfilePage() {
      this.$refs.addContent.clear();
      this.$refs.addDialog.show();
      this.$refs.addContent.loadNeForm();
    },
    saveAddTask() {
      const data = this.$refs.addContent.getFormData();
      if (data !== false) {
        this.dialogHide();
        this.$axios
          .post("/lte/ems/networkSlice/createServiceProfile", data)
          .then(response => {
            if (
              response &&
              response.status === 200 &&
              response.data.errorCode === "SUCCESS"
            ) {
              EventBus.$emit("toast", {
                type: "success",
                content: this.$t("NSMF.success")
              });
              this.getServiceProfileListData();
            } else {
              EventBus.$emit("toast", {
                type: "error",
                content: response.data.errorString
              });
            }
          });
      }
    },
    deleteServiceProfilePage() {
      // 删除任务
      const checkedDataList = this.getCheckedData(false);
      if (checkedDataList) {
        const checkedData = checkedDataList[0];
        this.$layer.confirm({
          msg: this.$t("NSMF.deleteServiceProfile"),
          btn1: { msg: this.$t("Common.cancel") },
          btn2: {
            msg: this.$t("Common.confirm"),
            func: () => {
              this.$axios
                .post(
                  `/lte/ems/networkSlice/delServiceProfile/${checkedData.id}`
                )
                .then(response => {
                  if (
                    response &&
                    response.status === 200 &&
                    response.data.errorCode === "SUCCESS"
                  ) {
                    EventBus.$emit("toast", {
                      type: "success",
                      content: this.$t("Common.tips.success")
                    });
                    this.getServiceProfileListData();
                  } else {
                    EventBus.$emit("toast", {
                      type: "error",
                      content: response.data.errorString
                    });
                  }
                });
            }
          }
        });
      }
    },
    getCheckedData(selectOnly) {
      // false: 不支持多选   true: 支持多选
      const selectedRecords = this.$refs.grid.getSelectedRecords();
      if (selectedRecords.length < 1) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.no_checked")}`
        });
        return false;
      }
      if (selectedRecords.length > 1 && !selectOnly) {
        EventBus.$emit("toast", {
          type: "warning",
          content: `${this.$t("Alarm.too_many_checked")}!`
        });
        return false;
      }
      return selectedRecords;
    },
    instanceServiceProfilePage() {
      const checkedDataList = this.getCheckedData(false);
      if (checkedDataList) {
        const checkedData = checkedDataList[0];
        this.$refs.instanceContent.init(checkedData);
        this.$refs.instanceDialog.show();
      }
    },
    prevInstance() {
      if (this.instanceIndex !== 0) {
        this.instanceIndex -= 1;
      }
    },
    nextInstance() {
      if (this.instanceIndex === 2) {
        //2是下一步按钮变为确定按钮
        this.addInstance();
      } else if (this.instanceIndex === 0) {
        let status =this.$refs.instanceContent.validation((res) =>{
        if (res) {
          this.instanceIndex += 1;
        }
        });

      } else if (this.instanceIndex === 1) {
        //1是目前在子网列表，下一步是子网网元配置
        let statusSliceProfile = this.$refs.instanceContent.validationSliceProfile();
        if (statusSliceProfile) {
          this.$refs.instanceContent.initNssi(statusSliceProfile[0],this.runModeRadioValue);
          this.instanceIndex += 1;
        }
      }
    },
    addInstance() {
      // if (this.instanceStatus) {
        //此字段避免重复点击
        // this.instanceStatus = false;
        // if (instanceInfo == null) {
        //   this.instanceStatus = true;
        //   return;
        // }
        this.$loading.showLoadding(this.$t('NSMF.addInstanceLoading'));
        const url = "/lte/ems/networkSlice/createNSI";
        this.$refs.instanceContent.getInstanceInfo(res=> {
           if (!res) {
         this.$loading.hideLoadding();
         return false;
          }  else{
        let That = this;
        this.$axios.post(url, res,{timeout: 60 * 4 * 1000}).then(response => {
          const result = response.data;
          console.log("result", result);
          if ( response &&response.status === 200 &&response.data.errorCode === "SUCCESS") {
            EventBus.$emit("toast", {type: "success",content: `${this.$t("Common.tips.success")}`});
            That.getServiceProfileListData();
          } else if(response && response.data.errorCode === "8602"){//目前不确定失败返回信息，暂定此写法
            this.$loading.hideLoadding();
            EventBus.$emit("toast", {
              type: "warning",
              content: response.data.errorString
            });
            return false;
          }
          else {            
            EventBus.$emit("toast", {
              type: "error",
              content: `${this.$t("Common.tips.failure")}`+' '+response.data.errorString           
            });
          }
          That.instanceIndex = 0;
          // That.instanceStatus = true;
          this.$loading.hideLoadding();
          That.$refs.instanceDialog.clear();
          That.$refs.instanceDialog.close();
        }).catch(err =>{
        this.$loading.hideLoadding();
        EventBus.$emit("toast", {
              type: "warning",
              content: `${this.$t("Common.tips.failure")}`
            });
      });
          }
        });
    },
    copyDeep(templateData) {
      const returnData = JSON.parse(JSON.stringify(templateData));
      returnData.buttonGroup.forEach((item, index) => {
        item.click = templateData.buttonGroup[index].click;
      });
      return returnData;
    }
  },
  mounted() {
    this.getServiceProfileListData();
  },
  watch: {
    instanceIndex() {
      const temp = this.copyDeep(this.dialog.element.instanceDialogSetting);
      if (this.instanceIndex === 2) {
        temp.buttonGroup[2].buttonModel.content = `${this.$t("Common.ok")}`;
        temp.buttonGroup[2].buttonModel.cssClass = "primary-btn";
      } else {
        temp.buttonGroup[2].buttonModel.content = `${this.$t("Common.next")}`;
        temp.buttonGroup[2].buttonModel.cssClass = "";
      }
      if (this.instanceIndex === 0) {
        temp.buttonGroup[1].buttonModel.cssClass = "h-security-display-none";
      } else {
        temp.buttonGroup[1].buttonModel.cssClass = "h-security-display-block";
      }
      this.dialog.element.instanceDialogSetting = temp;
    }
  },created(){
    EventBus.$on("runModeRadioValue", target => {
      console.log("target",target)
      this.runModeRadioValue = target;});
  }
};
</script>
